import React from 'react';
import { Field } from 'redux-form';
import RadioSelectorField from '../RadioSelectorField';
import { RadioSelectorButton } from '@cimpress-technology/ff-react-components/lib/RadioSelector';
import { EXISTING, NEW } from '../SelectPartyStep';
import { css } from 'emotion';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const radioSelectorStyle = css({
  display: 'flex',
  justifyContent: 'center'
});

const ChooseNewOrExistingContractField = ({ seller, t }) => {
  const buttons = (
    <React.Fragment>
      <RadioSelectorButton
        title={t('createContract:chooseNewOrExisting.existingButtonTitle')}
        value={EXISTING}
        description={t('createContract:chooseNewOrExisting.existingButtonDescription', {
          name: seller.name
        })}
      />
      <RadioSelectorButton
        title={t('common:actions.createNewContract')}
        value={NEW}
        description={t('createContract:chooseNewOrExisting.newButtonDescription', {
          name: seller.name
        })}
      />
    </React.Fragment>
  );

  return <Field component={RadioSelectorField} className={radioSelectorStyle} name="creationType" buttons={buttons} />;
};

ChooseNewOrExistingContractField.propTypes = {
  seller: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string
  })
};
ChooseNewOrExistingContractField.defaultProps = {
  seller: {
    name: 'seller'
  }
};

export default withTranslation()(ChooseNewOrExistingContractField);
